import { render } from "./sipAccountPrice.vue?vue&type=template&id=583ee976&scoped=true"
import script from "./sipAccountPrice.vue?vue&type=script&lang=js"
export * from "./sipAccountPrice.vue?vue&type=script&lang=js"

import "./sipAccountPrice.vue?vue&type=style&index=0&id=583ee976&scoped=true&lang=css"
import "./sipAccountPrice.vue?vue&type=style&index=1&id=583ee976&lang=css"
script.render = render
script.__scopeId = "data-v-583ee976"

export default script